export default {
    MARKERS: [
        {
            id: 1,
            hint_content: "Москва, Рязанский пр., 24к3",
            coords: {
                x: 37.776224,
                y: 55.720109
            },
        },
        {
            id: 2,
            hint_content: "Москва, Алтуфьевское шоссе, д. 31, стр. 1",
            coords: {
                x: 37.5803442,
                y: 55.86194
            },
        },
        {
            id: 3,
            hint_content: "Москва, Ярославское шоссе, д. 31",
            coords: {
                x: 37.688272,
                y: 55.859801
            },
        },
        {
            id: 4,
            hint_content: "Химки, Ленинградское шоссе, вл. 21",
            coords: {
                x: 37.412844,
                y: 55.905734
            },
        },
        {
            id: 5,
            hint_content: "Москва, ул. Обручева, д. 27, корп. 1",
            coords: {
                x: 37.535946,
                y: 55.656902
            },
        },
        {
            id: 6,
            hint_content: "Москва, 2-й Магистральный тупик, 5А",
            coords: {
                x: 37.523380,
                y: 55.767100
            },
        }
    ]
}
